import React from "react";
import EnhancedAdminDashboard from "./EnhancedAdminDashboard";

const DashboardWrapper = () => {
  return (
    <div>
      {/* Dashboard Content - Always Enhanced */}
      <EnhancedAdminDashboard />
    </div>
  );
};

export default DashboardWrapper;
